import { z } from 'zod';

import { iconSchema } from './icon.model';

export const HotelPerk = z.object({
  title: z.string(),
  icon: iconSchema,
  description: z.string().optional(),
});
